import { defineStyle as s, defineStyleConfig as a } from "@chakra-ui/styled-system";
import { runIfFn as l } from "../utils/run-if-fn.mjs";
import { inputTheme as d } from "./input.mjs";
var o;
const m = s({
  ...(o = d.baseStyle) == null ? void 0 : o.field,
  textAlign: "center"
}), u = {
  lg: s({
    fontSize: "lg",
    w: 12,
    h: 12,
    borderRadius: "md"
  }),
  md: s({
    fontSize: "md",
    w: 10,
    h: 10,
    borderRadius: "md"
  }),
  sm: s({
    fontSize: "sm",
    w: 8,
    h: 8,
    borderRadius: "sm"
  }),
  xs: s({
    fontSize: "xs",
    w: 6,
    h: 6,
    borderRadius: "sm"
  })
};
var r, f;
const p = {
  outline: s(
    (n) => {
      var e, i, t;
      return (t = (i = l((e = d.variants) == null ? void 0 : e.outline, n)) == null ? void 0 : i.field) != null ? t : {};
    }
  ),
  flushed: s(
    (n) => {
      var e, i, t;
      return (t = (i = l((e = d.variants) == null ? void 0 : e.flushed, n)) == null ? void 0 : i.field) != null ? t : {};
    }
  ),
  filled: s(
    (n) => {
      var e, i, t;
      return (t = (i = l((e = d.variants) == null ? void 0 : e.filled, n)) == null ? void 0 : i.field) != null ? t : {};
    }
  ),
  unstyled: (f = (r = d.variants) == null ? void 0 : r.unstyled.field) != null ? f : {}
}, y = a({
  baseStyle: m,
  sizes: u,
  variants: p,
  defaultProps: d.defaultProps
});
export {
  y as pinInputTheme
};
